import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class NavOnsiteRequest {
  constructor(init) {
    if (isNil(init)) return undefined
    this._employee_id = init.employee_id
    this._onsite_event_type = init.onsite_event_type
    this._request_details = init.request_details
    this._organization_name = init.organization_name
    this._user_email = init.user_email
    this._user_name = init.user_name
    this._user_phone_number = init.user_phone_number
    this._users_job_title = init.users_job_title
  }

  static shape = {
    employee_id: PropTypes.string.isRequired,
    onsite_event_type: PropTypes.string.isRequired,
    request_details: PropTypes.string.isRequired,
    organization_name: PropTypes.string,
    user_email: PropTypes.string,
    user_name: PropTypes.string,
    user_phone_number: PropTypes.string,
    users_job_title: PropTypes.string
  }

  get employee_id() {
    return this._employee_id
  }

  get onsite_event_type() {
    return this._onsite_event_type
  }

  get request_details() {
    return this._request_details
  }

  get organization_name() {
    return this._organization_name
  }

  get user_email() {
    return this._user_email
  }

  get user_name() {
    return this._user_name
  }

  get user_phone_number() {
    return this._user_phone_number
  }

  get users_job_title() {
    return this._users_job_title
  }
}

export default NavOnsiteRequest
